import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Admin from "apis/Admin";

// First, create the thunk
export const statisticsRequest = createAsyncThunk("statisticsList", async () => {
  const response = await Admin.get('statistics');
  console.log(response,"response statistics")
  return response.data.data
});

// Then, handle actions in your reducers:
const statisticsSlice = createSlice({
  name: "statistics",
  initialState: { statistics: [], totalList: '', message: "", loading: false },
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    
  },
  extraReducers: {
    // Add reducers for additional action types here, and handle loading state as needed
    [statisticsRequest.fulfilled]: (state, action) => {
      // Add key to the state array
      return { ...state, statistics: action.payload,  message:action.payload.message , loading: false };
    },
    [statisticsRequest.pending]: (state) => {
      return { ...state, loading: true };
    },
    [statisticsRequest.rejected]: (state, action) => {
      return {
        ...state,
        statistics: action.payload,
        message: "no data",
        loading: false,
      };
    },
  },
});


export default statisticsSlice.reducer;
